"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";

const navItems = [
  { href: "/", label: "판매 (POS)", icon: "🛒" },
  { href: "/history", label: "결제 내역", icon: "💳" },
  { href: "/inventory-log", label: "지점 재고 관리", icon: "📋" },
  { href: "/inventory", label: "재고 현황", icon: "📦" },
  { href: "/textbooks", label: "교재 관리", icon: "📚" },
  { href: "/admin", label: "관리자", icon: "⚙️" },
];

export default function Sidebar() {
  const pathname = usePathname();
  const router = useRouter();
  const [user, setUser] = useState<{ name: string; username: string; role: string; branchName?: string } | null>(null);

  useEffect(() => {
    fetch("/api/auth/me")
      .then((res) => res.json())
      .then((data) => {
        if (data.user) setUser(data.user);
        else setUser(null);
      })
      .catch(() => {});
  }, [pathname]);

  const handleLogout = async () => {
    await fetch("/api/logout", { method: "POST" });
    router.push("/login");
    router.refresh();
  };

  const isAdmin = user?.role === "ADMIN" || user?.role === "관리자";
  const isManager = user?.role === "MANAGER" || user?.role === "지점관리자";
  const canAccessAdmin = isAdmin || isManager;

  return (
    <aside className="sidebar" style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <div className="sidebar-logo">
        <div className="logo-icon">📖</div>
        <span>교재 판매관리(Multi)</span>
      </div>
      <nav className="sidebar-nav" style={{ flex: 1 }}>
        {navItems.map((item) => {
          // 본점관리자나 학원관리자가 아니면 관리자 메뉴 숨김
          if (item.href === "/admin" && !canAccessAdmin) {
            return null;
          }

          return (
            <Link
              key={item.href}
              href={item.href}
              className={pathname === item.href ? "active" : ""}
            >
              <span className="nav-icon">{item.icon}</span>
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>
      
      <div style={{ padding: "16px", borderTop: "1px solid rgba(255,255,255,0.1)", background: "rgba(0,0,0,0.2)" }}>
        {/* 학원명 (최상단) */}
        <div style={{ fontSize: "13px", color: "#3b82f6", fontWeight: 700, marginBottom: "8px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          🏢 {user?.branchName || "학원 정보 없음"}
        </div>
        
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
          {/* 아이디 및 권한 (좌측) */}
          <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
            <span style={{ fontSize: "14px", color: "#f1f5f9", fontWeight: 500 }}>
              {user ? user.username : "로그인 필요"}
            </span>
            <span style={{ fontSize: "11px", color: "#94a3b8" }}>
              {user ? user.role : "-"}
            </span>
          </div>
          
          {/* 로그아웃 버튼 (우측) */}
          {user && (
            <button 
              onClick={handleLogout}
              style={{ background: "transparent", border: "1px solid #475569", color: "#cbd5e1", borderRadius: "4px", padding: "4px 8px", cursor: "pointer", fontSize: "11px", transition: "all 0.2s" }}
              onMouseOver={(e) => { e.currentTarget.style.color = "#fff"; e.currentTarget.style.borderColor = "#64748b"; }}
              onMouseOut={(e) => { e.currentTarget.style.color = "#cbd5e1"; e.currentTarget.style.borderColor = "#475569"; }}
            >
              로그아웃
            </button>
          )}
        </div>
      </div>
      
      <div className="sidebar-footer">
        © 2026 교재 판매관리(Multi) 시스템
      </div>
    </aside>
  );
}
